import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";
import APIMediaSub from "./media/client";
import APITextSub from "./text/client";
import APIUserSub from "./user/client";

export default class APIMessages extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  user = new APIUserSub(this._client);
  text = new APITextSub(this._client);
  media = new APIMediaSub(this._client);

  getChats = async (): Promise<types.ChatResponse[]> => {
    let res = await this._fetch({
      url: `/messages/chats`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  getFeed = async ({
    page,
    size,
  }: {
    page?: number | null;
    size?: number | null;
  } = {}): Promise<types.PageMessageResponse> => {
    let res = await this._fetch({
      url: `/messages/feed`,
      method: "GET",
      params: { page: page, size: size },
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  postText = async ({
    ...body
  }: types.TextMessageCreate): Promise<types.MessageResponse> => {
    let res = await this._fetch({
      url: `/messages/text`,
      method: "POST",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  postPost = async ({ ...body }: types.PostCreate): Promise<any> => {
    let res = await this._fetch({
      url: `/messages/post`,
      method: "POST",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  postOffer = async ({ ...body }: types.OfferCreate): Promise<any> => {
    let res = await this._fetch({
      url: `/messages/offer`,
      method: "POST",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  postCounterOffer = async ({
    ...body
  }: types.CounterOffer): Promise<types.MessageResponse> => {
    let res = await this._fetch({
      url: `/messages/counter-offer`,
      method: "POST",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  postSystem = async ({
    ...body
  }: types.SystemCreate): Promise<types.MessageResponse> => {
    let res = await this._fetch({
      url: `/messages/system`,
      method: "POST",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  postMedia = async ({
    ...body
  }: types.BodyCreateMediaMessagesMediaPost): Promise<types.MessageResponse> => {
    let res = await this._fetch({
      url: `/messages/media`,
      method: "POST",
      body: body,
      bodyMime: "multipart/form-data",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  getMessageId = async (messageId: UUID): Promise<types.MessageResponse> => {
    let res = await this._fetch({
      url: `/messages/${messageId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  getPendingOffers = async (): Promise<types.PendingOffersResponse> => {
    let res = await this._fetch({
      url: `/messages/pending-offers`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
